import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/v2/icons/sms.svg")